import withMetadataArgument from './withMetadataArgument.js'
import { formatIncompletePhoneNumber as _formatIncompletePhoneNumber } from '../../core/index.js'

export function formatIncompletePhoneNumber() {
	return withMetadataArgument(_formatIncompletePhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/formatIncompletePhoneNumber.js
// module id = 1614
// module chunks = 0